var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMutedIcon = function SvgMutedIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M18 12a5.99 5.99 0 0 0-3.333-5.366V9.58l3.273 3.273c.04-.282.06-.567.06-.853zm3.334 0a9.229 9.229 0 0 1-.72 3.52l2.02 2.02A11.973 11.973 0 0 0 14.664.308v2.753A9.333 9.333 0 0 1 21.334 12zM1.702 0L0 1.7 6.3 8H0v8h5.333L12 22.667V13.7l5.674 5.673a9.387 9.387 0 0 1-3.007 1.574V23.7a11.96 11.96 0 0 0 4.913-2.413L22.3 24l1.7-1.7-12-12L1.702 0zM12 1.333L9.214 4.117 12 6.907V1.333z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMutedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/muted-icon.a2700b86f16972dddbd6e4784d551d17.svg";